module.exports = __webpack_public_path__ + "static/media/Titulo1_Vota_512.217eee97.png";